import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetExaminedDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { examinedData } from '../../../common/spdCore/contexts/ExaminedContext';
import { ExaminedEditor } from '../../components/Examined/ExaminedEditor';
import { ExaminedSearch } from '../../components/Examined/ExaminedSearch';

interface ExaminedListProps {
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  enableSingleSelect?: boolean;
  keyToSelect?: string;
  withAttachments?: boolean;
  withoutNewExamined?: boolean;
  examinedFirstname?: string;
  examinedSurname?: string;
  examinedEmail?: string;
  examinedPhone?: string;
  examinedInvoiceName?: string;
  examinedInvoiceAddress?: string;
  examinedNip?: string;
}

export const ExaminedList: React.FC<ExaminedListProps> = ({
  onRowClick,
  enableSingleSelect,
  keyToSelect,
  withAttachments,
  withoutNewExamined,
  examinedFirstname,
  examinedSurname,
  examinedEmail,
  examinedPhone,
  examinedInvoiceName,
  examinedInvoiceAddress,
  examinedNip,
}) => {
  const spd = useSpdCore();

  const [show, setShow] = useState(false);
  const [examined, setExamined] = useState<GetExaminedDto>();
  const [selectedKey, setSelectedKey] = useState<string | undefined>(
    keyToSelect,
  );

  const [refresh, setRefresh] = useState<boolean>(false);

  useEffect(() => {
    setSelectedKey(keyToSelect);
  }, [keyToSelect]);

  const handleAdd = () => {
    setShow(true);
    setExamined(undefined);
  };

  const handleCreated = (newId: string) => {
    setSelectedKey(newId);
    if (onRowClick) {
      void onRowClick(newId);
    }
  };

  const handleClose = () => {
    setShow(false);
    setRefresh(!refresh);
  };

  const handleClick = async (id: string) => {
    const getExamined = await spd.examineds.getExamined(id);
    setExamined(getExamined);
    setShow(true);
  };

  return (
    <>
      <ExaminedSearch
        getData={spd.examineds.getAllByPortion}
        getCount={spd.examineds.getAllCount}
        onRowClick={onRowClick ? onRowClick : handleClick}
        refresh={refresh}
        enableSingleSelect={enableSingleSelect}
        selectedKeys={[selectedKey || '']}
        withAttachments={withAttachments}
        withFilterInColumns={true}
      />
      {!withoutNewExamined && (
        <>
          <Button variant="outline-primary" onClick={handleAdd}>
            Nowy badany
          </Button>
          <ExaminedEditor
            id={examined?.id}
            examined={examinedData(
              examined,
              examinedFirstname,
              examinedSurname,
              examinedEmail,
              examinedPhone,
              undefined,
              examinedInvoiceName,
              examinedInvoiceAddress,
              examinedNip,
            )}
            show={show}
            handleClose={handleClose}
            onCreated={handleCreated}
            readOnly={false}
          />
        </>
      )}
    </>
  );
};
